// @flow

import React from 'react';
import { colors } from 'seedling/constants';

export type OpenQuoteIconProps = {
  width: number,
  height: number,
  color: string,
  className: string,
};

const OpenQuoteIcon = (props: OpenQuoteIconProps) => (
  <svg
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 29 21"
  >
    <path
      fill={props.color}
      d="M16.0823656,13.4624089 L16.0664737,13.4624089 C16.0664737,6.58198185 19.1881967,2.14768908 25.2537777,0.549504725 L26.0181427,3.45049528 C22.9327872,4.26343751 20.8999144,5.92784981 19.8690059,8.55449551 C20.6733567,8.19802935 21.5635522,8 22.5,8 C26.0898509,8 29,10.9101491 29,14.5 C29,18.0898509 26.0898509,21 22.5,21 C18.9101491,21 16,18.0898509 16,14.5 C16,14.1468507 16.028163,13.8002791 16.0823656,13.4624089 Z M0.0823656328,13.4624089 L0.0664737189,13.4624089 C0.0664737189,6.58198185 3.18819675,2.14768908 9.25377775,0.549504725 L10.0181427,3.45049528 C6.93278719,4.26343751 4.89991442,5.92784981 3.86900588,8.55449551 C4.67335665,8.19802935 5.56355221,8 6.5,8 C10.0898509,8 13,10.9101491 13,14.5 C13,18.0898509 10.0898509,21 6.5,21 C2.91014913,21 0,18.0898509 0,14.5 C0,14.1468507 0.028163021,13.8002791 0.0823656328,13.4624089 Z"
    />
  </svg>
);

OpenQuoteIcon.defaultProps = {
  color: colors.darkGrey,
  width: 29,
  height: 21,
};

export default OpenQuoteIcon;
